import { render, staticRenderFns } from "./AlertQuota.vue?vue&type=template&id=1cb5fde0&"
import script from "./AlertQuota.vue?vue&type=script&lang=js&"
export * from "./AlertQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports